import { FIELD_VALUES } from '@funnels/constants';

export const assetPurposeText = (assetPurpose: FIELD_VALUES | undefined) => {
  switch (assetPurpose) {
    case FIELD_VALUES.NEW_PURCHASE:
      return 'New purchase';
    case FIELD_VALUES.OTHER:
      return 'Other';
    case FIELD_VALUES.REFINANCE:
      return 'Refinance';
    case FIELD_VALUES.SECURITY_PROPERTY:
      return 'Security property';
    default:
      return '';
  }
};
